import {
  LayoutDashboard, Users, Home, Briefcase, Calendar, KanbanSquare, FileText, Receipt, CreditCard,
  BookOpen, Package, TriangleAlert, MessagesSquare, BarChart3, Settings, ClipboardList,
} from 'lucide-react';
import { NAV } from '@/constants/testIds';

// Single source of truth for admin navigation. The desktop sidebar, the mobile
// drawer, and the mobile bottom bar all read from here so they can never drift.
export const adminNav = [
  { group: 'Operations', items: [
    { to: '/', label: 'Dashboard', icon: LayoutDashboard, testid: NAV.toDashboard, end: true },
    { to: '/jobs', label: 'Jobs', icon: Briefcase, testid: NAV.toJobs },
    { to: '/calendar', label: 'Calendar', icon: Calendar, testid: NAV.toCalendar },
    { to: '/pipeline', label: 'Pipeline', icon: KanbanSquare, testid: NAV.toPipeline },
  ]},
  { group: 'CRM', items: [
    { to: '/customers', label: 'Customers', icon: Users, testid: NAV.toCustomers },
    { to: '/properties', label: 'Properties', icon: Home, testid: NAV.toProperties },
    { to: '/inbox', label: 'Inbox', icon: MessagesSquare, testid: NAV.toInbox },
  ]},
  { group: 'Finance', items: [
    { to: '/estimates', label: 'Estimates', icon: FileText, testid: NAV.toEstimates },
    { to: '/invoices', label: 'Invoices', icon: Receipt, testid: NAV.toInvoices },
    { to: '/payments', label: 'Payments', icon: CreditCard, testid: NAV.toPayments },
  ]},
  { group: 'Catalog', items: [
    { to: '/pricebook', label: 'Price Book', icon: BookOpen, testid: NAV.toPricebook },
    { to: '/inventory', label: 'Inventory', icon: Package, testid: NAV.toInventory },
  ]},
  { group: 'Quality', items: [
    { to: '/issues', label: 'Issue Reports', icon: TriangleAlert, testid: NAV.toIssues },
    { to: '/service-requests', label: 'Service Requests', icon: ClipboardList, testid: 'nav-service-requests-link' },
  ]},
  { group: 'Admin', items: [
    { to: '/reports', label: 'Reports', icon: BarChart3, testid: NAV.toReports },
    { to: '/settings', label: 'Settings', icon: Settings, testid: NAV.toSettings },
  ]},
];

// Sixteen destinations do not fit a phone tab bar. These four are the ones an
// admin opens between jobs; everything else lives one tap away behind "More".
export const adminMobileTabs = [
  { to: '/', label: 'Home', icon: LayoutDashboard, end: true, testid: 'mobile-tab-dashboard' },
  { to: '/jobs', label: 'Jobs', icon: Briefcase, testid: 'mobile-tab-jobs' },
  { to: '/calendar', label: 'Calendar', icon: Calendar, testid: 'mobile-tab-calendar' },
  { to: '/inbox', label: 'Inbox', icon: MessagesSquare, testid: 'mobile-tab-inbox' },
];

export const cleanerTabs = [
  { to: '/my-day', label: 'My Day', icon: ClipboardList, testid: NAV.mobileTabMyDay },
  { to: '/jobs', label: 'Jobs', icon: Briefcase, testid: NAV.mobileTabJobs },
  { to: '/inbox', label: 'Inbox', icon: MessagesSquare, testid: NAV.mobileTabInbox },
  { to: '/inventory', label: 'Inventory', icon: Package, testid: NAV.mobileTabInventory },
  { to: '/profile', label: 'Profile', icon: Users, testid: NAV.mobileTabProfile },
];
